import { Module } from 'wrapper6';

export default class AccordionWidget extends Module {
    ready(app) {
        this.accordionItems = document.querySelectorAll('.mtt-accordion-widget__item');
        this.accordionTitles = document.querySelectorAll('.mtt-accordion-widget__item-title');
        this.openClass = 'mtt-accordion-widget__item--open';

        if (this.accordionTitles.length) {
            this.addEventListeners();
        }
    }

    addEventListeners() {
        for (let i = 0; i < this.accordionTitles.length; i++) {
            const TRIGGER = this.accordionTitles[i];
            const PARENT = TRIGGER.parentNode;

            TRIGGER.addEventListener('click', () => {
                if(PARENT.classList.contains(this.openClass) === false) {
                    this.closeAllAccordions();
                    PARENT.classList.add(this.openClass)
                } else {
                    PARENT.classList.remove(this.openClass)
                }
            });
        }
    }

    closeAllAccordions() {
        for (let i = 0; i < this.accordionItems.length; i++) {
            const ITEM = this.accordionItems[i];
            ITEM.classList.remove(this.openClass);
        }
    }
}